import { DeleteTwoTone } from '@ant-design/icons'
import { Row, Col, Input, Popconfirm, Button } from 'antd'
import CIMSFormItem from '../../CIMSFormItem'
import { FormListFieldData } from 'antd/lib/form/FormList'
import { useExternalLinkEditorContext } from './ExternalLinkEditorContext'
import ExternalLinkEditorAutoComplete from './ExternalLinkEditorAutoComplete'

/** @private */
const ExternalLinkEditorRow: React.VFC<FormListFieldData> = ({
  name,
  ...rest
}) => {
  const { disabled, remove } = useExternalLinkEditorContext()
  return (
    <Row justify="space-between" gutter={16}>
      <Col flex={2}>
        <CIMSFormItem
          label="Label"
          name={[name, 'label']}
          requiredMessage="Please enter a label"
        >
          <ExternalLinkEditorAutoComplete />
        </CIMSFormItem>
      </Col>
      <Col flex={3}>
        <CIMSFormItem
          {...rest}
          label="Reference"
          name={[name, 'href']}
          requiredMessage="Please enter a reference"
          url
        >
          <Input allowClear disabled={disabled} />
        </CIMSFormItem>
      </Col>
      <Col flex="32px">
        <Popconfirm
          disabled={disabled}
          title="Are you sure you want to remove this External Link? This action cannot be undone!"
          onConfirm={() => remove(name)}
        >
          <Button icon={<DeleteTwoTone />} disabled={disabled} type="text" />
        </Popconfirm>
      </Col>
    </Row>
  )
}

export default ExternalLinkEditorRow
